import { render } from "./QuantityControl.vue?vue&type=template&id=a85af460&scoped=true&ts=true"
import script from "./QuantityControl.vue?vue&type=script&lang=ts"
export * from "./QuantityControl.vue?vue&type=script&lang=ts"

import "./QuantityControl.vue?vue&type=style&index=0&id=a85af460&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85af460"]])

export default __exports__